import React,{useState,useCallback,useMemo} from 'react';
import {DialogActions,DialogContent,DialogTitle,Paper,Button,Dialog,CircularProgress, Tooltip} from '@material-ui/core';
import DataTable from "react-data-table-component";
import Draggable from 'react-draggable';
import {ModeComment} from '@material-ui/icons';
import { useStyles, paperPropsComs } from '../../../css/muiStyle';
import {customStyles} from '../../../css/datatable-custom'
import { useContext } from 'react';
import ParamContext from '../../../Contexte';
import {AlertCompo} from '../../../js/components'

//Add a new role
function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  )
}

export default function Comments(props) {
    const classes=useStyles();
    const Gfunc=require('../../../Gfunc')
    const param=useContext(ParamContext);
    const [open, setOpen] = useState(false);
    const [comments, setComments] = useState([]);
    const [openA, setOpenA] =useState(false)
    const [messageA, setMessageA] =useState('');
    const [severity, setSeverity] =useState('info');
    const service="_prd.php"

    const conditionalRowStyles= [
      {
        when: row => row.new===true,
        style: {
          color: '#990000',
        },
      },
    ];

    //handle Alerts
    const handleAlert=(open,severity,message)=>{
      setOpenA(true)
      setSeverity(severity)
      setMessageA(message)
      setTimeout(function(){
        setOpenA(false)
      }, 5000);
    }

    const handleClickOpen = () => { 
      setOpen(true); 
      fetch()
      const objIndex = comments.findIndex((obj => obj.new ===true )); 
      if(objIndex!==-1) {handleChangeStatueCom()}
    };

    const handleClose = () => { setOpen(false); };

    //fetch comments of news
    const fetch= useCallback(async() => {
        const response=await Gfunc.axiosPostAction(service,"getpcoms",{idp:(props.from==='online')?props.row.produitId:parseInt(props.row.DT_RowId.substr(1))})
        if(response.data.err&&response.data.err!=='-1'){
          handleAlert(true,"error",response.data.err)
        }else{
          Gfunc.axiosResponse(response,()=>{
            if(response.data.jData){
              setComments(response.data.jData);
            }
          })
        }
    },[props.row.DT_RowId,Gfunc])

    const handleChangeStatueCom=useCallback(async() => {
        const response=await Gfunc.axiosPostAction(service,"setncomviewed",{idn:(props.from==='online')?props.row.produitId:props.row.DT_RowId.substr(1)})
        if(response.data.err&&response.data.err!=='-1'){
          handleAlert(true,"error",response.data.err)
        }else{
          Gfunc.axiosResponse(response,()=>{
          })
        }
    },[props.row.DT_RowId,Gfunc])

    const columns =useMemo(
      () => [ 
          {
            name: "Commentaire",
            selector: row=>row.comment,
            sortable: true, 
            minWidth:"450px !important",
            cell: (row) => {
              return (
                <div className="note-container">
                {((row.comment&&row.comment.match(/\r/g) || []).length>=1)?
                 <Tooltip title={row.comment.replaceAll("\r", "/ ")}>
                     <div className='note-content'>{row.comment.substring(0, row.comment.indexOf("\r"))+"..."}</div>
                 </Tooltip>:
                   <Tooltip title={row.comment?row.comment:''}>
                 <div className='note-content'>{row.comment}</div></Tooltip>}
                 </div>
               );
             },
          },
          {
            name: "Par",
            selector: row=>row.nom+' '+row.prenom,
            sortable: true,
            minWidth:'160px !important',

          },
          {
            name: "Date",
            selector: row=>row.date_comment,
            sortable: true,
            minWidth:'130px !important',
          },
          {
            name: "Commune",
            selector: row=>row.commune,
            sortable: true,
            minWidth:'140px !important'
          },
          {
            name: "Magasin",
            selector: row=>row.mag,
            sortable: true,
            minWidth:'130px !important'
          },
          {
            name: "Tel",
            selector: row=>row.tel,
            sortable: true,
            width:'100px !important'
          },     
        ],[]);
  
  return (
    <div>
      <Tooltip title={props.nbr+" commentaire"}>
        <ModeComment fontSize='small' onClick={handleClickOpen} className={classes.blackIcon}/>
      </Tooltip>
      <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            PaperProps={paperPropsComs}
       >
        <DialogTitle className={classes.topDivTitle} id="draggable-dialog-title" >La liste des commentaires</DialogTitle>
        <AlertCompo severity={severity} open={openA} setOpen={setOpenA} message={messageA}/>  
        <DialogContent>
           <div id='child-1'>
             <DataTable
                key={Math.floor(Math.random() * 100)}
                columns={columns}
                data={comments}
                noDataComponent={param.ErreurData}
                defaultSortAsc={true}
                paginationRowsPerPageOptions={[5, 10, 20, 30]}
                pagination
                highlightOnHover
                customStyles={customStyles}
                selectableRowsComponentProps={{ className: classes.checkStelect }}
                paginationComponentOptions={{ rowsPerPageText: 'Élément par page:', rangeSeparatorText: 'sur', selectAllRowsItemText: 'Tous',selectAllRowsItem: true}}
                contextMessage={{ singular: 'élément sélectionné', plural: 'éléments sélectionnés' }}
                progressComponent={<CircularProgress className="circularProgress" />}
                conditionalRowStyles={conditionalRowStyles}
             />
          </div>
        </DialogContent>
        <DialogActions id='btn-div'>
          <Button variant="contained"  onClick={handleClose} color="secondary">FERMER</Button>
        </DialogActions>
      </Dialog>
      </div>
  );
}
